/* eslint-disable */
import template from './template'
import store from '@/store'

console.log('Generate horizontal menu')
export default [
  ...template,
]
